<template>
  <span
    class="ma-1"
    @click="viewWork"
  >
    <v-tooltip
      :disabled="!data.omnibusWork.hasWork"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          class="chip"
          :class="{'chip--hasWork': data.omnibusWork.hasWork}"
          v-on="on"
        >
          {{ data.name }}
        </span>
      </template>
      <span>
        Titre : {{ data.omnibusWork.title }}
      </span>
    </v-tooltip>
  </span>
</template>

<script>
  export default {
    props: {
      data: Object,
    },
    methods: {
      viewWork () {
        if (!this.data.omnibusWork.hasWork) {
          return
        }
        const token = localStorage.getItem('jwt')
        const url = this.$http.getApiUrl(`/participant/classes/work/${this.data.omnibusWork.storagePath}?token=${token}`)
        window.open(url, '_blank')
      },
    },
  }
</script>

<style scoped>
.chip {
  background-color:#DDD;
  padding: 7px;
  border-radius: 6px;
  color: back;
}

.chip--hasWork {
  background-color:rgb(0, 101, 126);
  color: white;
  font-weight: bold;
  cursor: pointer;
}
</style>
